module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="trade-player-pool-table-head-container">\n	<div class="trade-player-pool-table-head table-head">\n		<div class="column column-1 match-stat-column" data-order-by="squad_id">Round</div>\n		<div class="column column-2 match-stat-column player-opponent-column" data-order-by="name">Opponent</div>\n		<div class="column column-3 match-stat-column">Venue</div>\n		<div class="column column-4 match-stat-column">Score</div>\n\n		';
 _.each(headings, function(item, index) { 
__p+='\n			<div class="column column-'+
((__t=( index + 5 ))==null?'':_.escape(__t))+
' tooltip-team js-order-by match-stat-column '+
((__t=( item.key === 'TOG' ? '' : '' ))==null?'':_.escape(__t))+
'"\n				 title="'+
((__t=( item.tooltip ))==null?'':_.escape(__t))+
'"\n				 data-order-by="match_stats.'+
((__t=( item.key ))==null?'':_.escape(__t))+
'">\n				'+
((__t=( item.heading ))==null?'':_.escape(__t))+
'\n			</div>\n		';
 }) 
__p+='\n	</div>\n</div>';
}
return __p;
};
